export { default } from './GlobalModule';
